export default __webpack_public_path__ + "static/media/Heel-Pain-1.b4cf2ea4.jpg";